module.exports = __webpack_public_path__ + "img/aze.451284ce.svg";